import { render } from "./InstallerCompleteScreen.vue?vue&type=template&id=a67db3fe&scoped=true"
import script from "./InstallerCompleteScreen.vue?vue&type=script&lang=js"
export * from "./InstallerCompleteScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=a67db3fe&lang=scss&scoped=true"
import "./InstallerCompleteScreen.vue?vue&type=style&index=1&id=a67db3fe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67db3fe"]])

export default __exports__